<template>

  <ModalContainer queryParam="f020" ref="modalContainer" size="lg">
    <b-alert v-if="messageAlert && !isLoading" show :variant="messageAlert.variant" class="p-2 text-center">
      {{ messageAlert.text }}
    </b-alert>

    <b-card class="mb-0" v-if="!isLoading">

      <h3 class="text-center mb-1">Cargar Formulario 020</h3>

        <div class="mb-1 row p-1" v-if="dataProceso">
          <div class="col"><b>Procedimiento:</b> {{ dataProceso.procedimiento }}</div>
          <div class="col"><b>Paciente: </b> {{ dataProceso.paciente }}</div>
        </div>


      <hr class="mb-3" />

      <LoadFileInput v-model="newFile020" :urlFile="urlFile020" label="Formulario 020" class="mb-3" />

      <div class="d-flex justify-content-end">
        <b-button variant="primary" @click="onSaveFile">
          Guardar
        </b-button>
      </div>

    </b-card>

    <GeneralLoader v-if="isLoading" class="p-3" />
  </ModalContainer>

</template>

<script>
import { ModalContainer, LoadFileInput, GeneralLoader } from "@/shared/components";
import { fileService } from "@/shared/services";

import { procedimientosFormulariosService } from "../../services";

export default {

  name: "Formulario020",

  components: {
    ModalContainer,
    LoadFileInput,
    GeneralLoader
  },

  created() {
    this.loadData();
  },

  data() {

    return {
      isLoading: false,

      newFile020: null,
      urlFile020: null,

      tokenFormulario: null,
      tokenProceso: null,
 
      idRegistroForm: null,

      messageAlert: null,
      codigoFormulario: '020',

    }
  },


  methods: {
    async loadData() {

      this.isLoading = true

      this.clearDataForm();

      this.tokenProceso = this.$route.query.forms;

      this.tokenFormulario = this.$route.query.f020;

      const response = await procedimientosFormulariosService.obtenerFormProcDataByToken(this.tokenFormulario);
      console.log("response", response)
      if (!response) {
        this.isLoading = false
        
        return
      }


      this.messageAlert = { text: "Info registrada", variant: "success" };

      let paciente = `${response.procedimientoCita.consultamedica.cita.paciente.persona.primerApellido} ${response.procedimientoCita.consultamedica.cita.paciente.persona.primerNombre} `

     

      let dataForm = null;
      try {
        dataForm = JSON.parse(response.dataJson);
      } catch (e) {
        console.warn("dataJson inválido:", e);
      }

      if (dataForm && dataForm.urlFile) {
        this.urlFile020 = dataForm.urlFile;
      }

      this.isLoading = false
    },


    async onSaveFile() {

      const result = await this.$swal({
        title: "Guardar Archivo",
        text: "¿Esta seguro de guardar el archivo?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Guardar!",
        cancelButtonText: "Cancelar",
      });

      if (!result.isConfirmed) return;


      const uploadFile = await fileService.upload(
        'procesos_formularios',
        this.newFile020,
        'f020',
        this.urlFile020
      );

      const dataForm = {
        urlFile: uploadFile
      }


      // validacion de eliminacion
      if (this.newFile020 === undefined)
        await fileService.deleteFile(this.urlFile020);

      const params = {
        nameForm: this.codigoFormulario,
        dataJson: JSON.stringify(dataForm),
        tokenProceso: this.tokenProceso,
        tokenFormulario: this.tokenFormulario,
        idRegistroForm: this.idRegistroForm
      };

      const responseSave = await procedimientosFormulariosService.guardarData(params);

      if (!responseSave) {
        this.$swal({
          title: "Error",
          text: "No se guardo! Contacte al equipo de desarrollo",
          icon: "error",
          confirmButtonColor: "#089599",
        });

        return;
      }

      await this.$swal.fire({
        icon: "success",
        text: "Guardado correctamente",
      });
      
      await this.$router.push({
        query: {
          ...this.$route.query,
          f020: undefined
        }
      });


      

      // await this.$router.push({ query: { ...this.$route.query, finf: undefined } });
      this.$emit("formulario-guardado");

    },

    clearDataForm() {
      this.newFile020 = null;
      this.urlFile020 = null;
    }
  },
   props:{
    dataProceso:{
      default:null,
      required:false
    }
  },


  watch: {

    '$route.query.f020': {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.loadData();
        }

      }
    }
  }

}
</script>